export default __webpack_public_path__ + "media/color/rdd-d633d468.svg";